<template>
  <div class="mobile-box">
    <nav-web style="background-color: #000C2A"></nav-web>
    <div class="mobile-content">
      <div class="m-title-box">
        平台优势
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        新能源城市配送共享服务平台上线运营后已获取足够多的参与方和运营数据，通过自建的大数据平台和人工智能充分发挥平台智能化优势。为运力企业提供数字化、标准化、智能化调度与管控服务，构建智慧城市下的智慧物流网络，提升运力效率，降低运输成本。
      </div>
      <div class="m-peculiarity">
        <div class="m-peculiarity-item m-consignor">
          <div class="m-pe-icon m-icon-tran1"></div>
          <div class="m-pe-text">
            <div>海量用户 资源</div>
          </div>
        </div>
        <div class="m-peculiarity-item m-consignor">
          <div class="m-pe-icon m-icon-tran2"></div>
          <div class="m-pe-text">
            <div>平台智能</div>
          </div>
        </div>
        <div class="m-peculiarity-item m-consignor">
          <div class="m-pe-icon m-icon-tran3"></div>
          <div class="m-pe-text">
            <div>大数据 人工智能</div>
          </div>
        </div>
      </div>
      <div class="m-data-explain">
        <div class="m-img-big img-tran1"></div>
      </div>


      <div class="m-title-box" style="margin-top: 60px;">
        车队管理高效化
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        新能源城市配送共享服务平台，可帮助运力企业高效化的管理车队。通过自建的智慧物流大数据平台和人工智能技术，帮助企业安全管理车辆，通过车辆调度来优化行程，实现车队成本控制。
      </div>
      <div class="m-peculiarity">
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tran4"></div>
          <div class="m-pe-text">
            <div>车队成本</div>
            <div>控制</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tran5"></div>
          <div class="m-pe-text">
            <div>车辆调度</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tran6"></div>
          <div class="m-pe-text">
            <div>车辆安全</div>
            <div>管理</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tran7"></div>
          <div class="m-pe-text">
            <div>行程优化</div>
          </div>
        </div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">30<span>%</span></div>
          <div class="m-de-item-text">空返率降低30%</div>
        </div>
        <div class="m-data-explain-item"></div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">50<span>%</span></div>
          <div class="m-de-item-text">调度成本降低50%</div>
        </div>
        <div class="m-data-explain-item">
          <div class="m-de-item-img img-tran2"></div>
        </div>
      </div>

      <div class="m-title-box" style="margin-top: 60px;">
        财务透明化
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        新能源城市配送共享服务平台支持企业管理人员对企业员工的收支管理以及结算等操作，企业管理人员还可实时查看企业的账务明细，方便企业进行财务核算，为企业提供在线申请发票的便捷入口。
      </div>
      <div class="m-peculiarity">
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tran8"></div>
          <div class="m-pe-text">
            <div>收入结算</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tran9"></div>
          <div class="m-pe-text">
            <div>成本结算</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tran10"></div>
          <div class="m-pe-text">
            <div>工资结算</div>
          </div>
        </div>
        <div class="m-peculiarity-item">
          <div class="m-pe-icon m-icon-tran11"></div>
          <div class="m-pe-text">
            <div>财务核算</div>
          </div>
        </div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">在线对账</div>
          <div class="m-de-item-text">提供多维度财务报表</div>
        </div>
        <div class="m-data-explain-item"></div>
      </div>
      <div class="m-data-explain">
        <div class="m-data-explain-item">
          <div class="m-de-item-num">实时查看</div>
          <div class="m-de-item-text">企业账户明细实时查看</div>
        </div>
        <div class="m-data-explain-item">
          <div class="m-de-item-img img-tran3"></div>
        </div>
      </div>

      <div class="m-title-box" style="margin-top: 60px;">
        业务定制化
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        新能源城市配送共享服务平为运力企业提供业务定制化服务，运力企业可结合企业自身的实际情况，定制化贴合企业业务模式的智慧物流系统，实现线上+线下完美结合。
      </div>
      <div class="m-peculiarity">
        <div class="m-peculiarity-item m-consignor">
          <div class="m-pe-icon m-icon-tran12"></div>
          <div class="m-pe-text">
            <div>合同创建</div>
          </div>
        </div>
        <div class="m-peculiarity-item m-consignor">
          <div class="m-pe-icon m-icon-tran13"></div>
          <div class="m-pe-text">
            <div>合同订单</div>
          </div>
        </div>
        <div class="m-peculiarity-item m-consignor">
          <div class="m-pe-icon m-icon-tran14"></div>
          <div class="m-pe-text">
            <div>合同流程</div>
          </div>
        </div>
        <div class="m-peculiarity-item m-consignor">
          <div class="m-pe-icon m-icon-tran15"></div>
          <div class="m-pe-text">
            <div>业务统计</div>
          </div>
        </div>
      </div>
      <div class="m-data-explain" >
        <div class="m-img-big img-tran4"></div>
      </div>

      <div class="m-title-box" style="margin-top: 60px;">
        合作模式
        <div class="m-title-line"></div>
      </div>
      <div class="m-describe">
        新能源城市配送共享服务平台可为运力企业提供定制化合作模式，运力企业可根据自身实际情况选择适合自己的一种或多种组合的合作模式。
      </div>
      <div class="m-hzms-box">
          <div class="hzms-item">
            <div class="item-img img1"></div>
            <div class="item-text">货运物流服务</div>
          </div>
          <div class="hzms-item">
            <div class="item-img img2"></div>
            <div class="item-text">税筹物流服务</div>
          </div>
          <div class="hzms-item">
            <div class="item-img img3"></div>
            <div class="item-text">平台SaaS服务</div>
          </div>
      </div>
    </div>
    <div class="mobile-btns">
      <div class="m-btn" @click="gotoPage">申请入驻</div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        tzData:{
          name:'',//姓名
          telephone:'',//
          email:'',//
          cityCode:'510000',//
          city:'四川省',//
          businessType:'大客户',//业务类型 1-大客户 2-投资 3-加盟
          addCity:'成都',//加盟城市
          addArea:'600㎡以下',//加盟面积
          addCharging:'60kw以下',//充电桩
          addCooperationMode:'建站方案策划',//合作模式
          addEstimatedCost: '50000.00',//加盟预计费用
          path:'/intelligentlogistics',
        }
      }
    },
    mounted() {},
    methods: {
      gotoPage(){
        this.$router.push({
          name: 'mobileApply',
          params: this.tzData
        });
      },
    },
  }
</script>
<style src="./../../styles/mobile.less" lang="less" scoped></style>
